module.exports = __webpack_public_path__ + "static/media/d3.1b023c80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/d3.svg
// module id = 55
// module chunks = 0